import axios from "axios";

class SystemSettings {
  get() {
    return axios.get("/system-setting");
  }
  change(data) {
    return axios.put("/system-setting", data);
  }
  setPriceSource(data) {
    return axios.patch("/system-setting/fiat-price-source", data);
  }
  // Auto Change Settings
  getAutoChangeSettings() {
    return axios.get("/system-setting/auto-change");
  }
  updateAutoChangeSettings(data) {
    return axios.post("/system-setting/auto-change", data);
  }
  autoChangeSettingsGetData() {
    return axios.get("/system-setting/auto-change/data");
  }
  getAutoChangeBalances() {
    return axios.get("/crypto-auto-change/balances");
  }
  getAutoChangeCurrencies() {
    return axios.get("/crypto-auto-change/currencies");
  }
  createAutoChangeConversion(data) {
    return axios.post("/crypto-auto-change/conversion", data);
  }
  createAutoChangePayout(data) {
    return axios.post("/crypto-auto-change/payout", data);
  }
  getAutoChangePaymentsHistory(page = 0, limit = 50) {
    return axios.get(`/crypto-auto-change/payments-history?page=${page}&limit=${limit}`);
  }
  getAutoChangePayoutsHistory(page = 0, limit = 50) {
    return axios.get(`/crypto-auto-change/payouts-history?page=${page}&limit=${limit}`);
  }

  // /system-setting/auto-change/data
}

export default new SystemSettings();
